'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DeviceUnsupported = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = require('react-router');

var _reactIntl = require('react-intl');

var _isMobile = require('helpers/isMobile');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceUnsupported = exports.DeviceUnsupported = function DeviceUnsupported(_ref) {
  var handleStandardPlay = _ref.handleStandardPlay;
  return _react2.default.createElement(
    'div',
    { className: 'modal__device-unsupported' },
    _react2.default.createElement(
      'div',
      { className: 'modal__device-setup__top' },
      _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'device.unsupported-header',
        defaultMessage: 'Browser not supported',
        tagName: 'h3'
      }),
      _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'device.unsupported-browser',
        className: 'mb0',
        defaultMessage: 'The interactive workout experience is currently only supported in the Google Chrome browser for Mac or Windows 10.',
        tagName: 'p'
      })
    ),
    _react2.default.createElement(
      'div',
      { className: 'modal__device-setup__content' },
      _react2.default.createElement('img', { src: require('../../../static/img/chrome-logo.png'), alt: 'chrome', className: 'modal__device-unsupported__chrome-logo' })
    ),
    !(0, _isMobile.isMobileDevice)() && navigator && navigator.platform.indexOf('Mac') !== -1 && _react2.default.createElement(
      'a',
      { href: 'https://www.google.com/chrome/', target: '_blank', rel: 'noopener noreferrer', className: 'bt bt--primary bt--solid' },
      _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'device.launch.chrome',
        defaultMessage: 'Get the Chrome browser'
      })
    ),
    _react2.default.createElement(
      _reactRouter.Link,
      { onClick: handleStandardPlay, className: 'block pl- mt+' },
      _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'play.video',
        defaultMessage: 'Watch video only'
      })
    )
  );
}; /* eslint-disable react/prefer-stateless-function */


DeviceUnsupported.propTypes = {
  handleStandardPlay: _propTypes2.default.func
};